__turbopack_context__.v({
  "backdrop": "SearchDialog-module__uxig6q__backdrop",
  "expandingBox": "SearchDialog-module__uxig6q__expandingBox",
  "expandingBoxContained": "SearchDialog-module__uxig6q__expandingBoxContained",
  "innerResultsContainer": "SearchDialog-module__uxig6q__innerResultsContainer",
  "list": "SearchDialog-module__uxig6q__list",
  "listOutline": "SearchDialog-module__uxig6q__listOutline",
  "outerScrollContent": "SearchDialog-module__uxig6q__outerScrollContent",
  "outerScrollRoot": "SearchDialog-module__uxig6q__outerScrollRoot",
  "outerScrollViewport": "SearchDialog-module__uxig6q__outerScrollViewport",
  "outerScrollbar": "SearchDialog-module__uxig6q__outerScrollbar",
  "popup": "SearchDialog-module__uxig6q__popup",
  "popupContained": "SearchDialog-module__uxig6q__popupContained",
  "popupNonContained": "SearchDialog-module__uxig6q__popupNonContained",
  "resultsContainer": "SearchDialog-module__uxig6q__resultsContainer",
  "scrollAreaRoot": "SearchDialog-module__uxig6q__scrollAreaRoot",
  "scrollThumb": "SearchDialog-module__uxig6q__scrollThumb",
  "scrollViewport": "SearchDialog-module__uxig6q__scrollViewport",
  "scrollbar": "SearchDialog-module__uxig6q__scrollbar",
  "shrink0": "SearchDialog-module__uxig6q__shrink0",
  "stats": "SearchDialog-module__uxig6q__stats",
  "statsHidden": "SearchDialog-module__uxig6q__statsHidden",
  "viewport": "SearchDialog-module__uxig6q__viewport",
  "viewportContained": "SearchDialog-module__uxig6q__viewportContained",
});
